import React from "react";
import PdfDocumentTable from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";

const fposStateWiseDocuments = [
  {
    serial: 1,
    title:
      "Statewise details of FPOs registered under Central Sector Scheme for Formation and Promotion of 10,000 FPOs during 2021-22",
    fileName:
      "Statewise details of FPOs registered under Central Sector Scheme for Formation and Promotion of 10,000 FPOs during 2021-22",
    href: "https://docs.google.com/spreadsheets/d/1ZgyxHFH_5pQrepkxeb5uiyG1HTC2uU0-/edit#gid=990861273",
    external: true,
    fileType: "spreadsheet",
  },
  {
    serial: 2,
    title:
      "Statewise details of FPOs registered under Central Sector Scheme for Formation and Promotion of 10,000 FPOs during 2020-21",
    fileName:
      "Statewise details of FPOs registered under Central Sector Scheme for Formation and Promotion of 10,000 FPOs during 2020-21",
    href: "https://docs.google.com/spreadsheets/d/1IeIk6dZZUhI3sbrEeYV5DYkrv7ZjNvnA/edit?gid=1849305161#gid=1849305161",
    external: true,
    fileType: "spreadsheet",
  },
];

const FposStateWiseDetails = () => (
  <section className="min-w-0 flex-1">
    <h2 className="mb-3 text-[18px] font-bold text-[#005856]">
      FPOs State Wise Details
    </h2>
    <PdfDocumentTable
      documents={fposStateWiseDocuments}
      minWidth="700px"
      showSerial={false}
    />
  </section>
);

export default FposStateWiseDetails;
